import PageTitle from "../components/custom/PageTitle";

const contractSections = [
  {
    title: "1. Subject of Contract",
    clauses: [
      "1.1 The Bank advances the Borrower with a loan in the currency and amount with an annual interest rate and loan terms as specified in the Payment plan.",
      "1.2 The Borrower hereby undertakes the obligation to repay the Loan principal amount and interest, according to the repayment schedule.",
    ],
  },
  {
    title: "2. Loan Disbursement",
    clauses: [
      "2.1 The loan offer is accepted, and the funds is disbursed into your bank account and transferred to your MTN mobile wallet.",
    ],
  },
  {
    title: "3. Repayment of Loan and Interest",
    clauses: [
      "3.1 The Borrower shall pay the Bank in the currency in which the loan was disbursed.",
      "3.2 The Bank will debit the Borrower's Account with the payable installments according to the repayment plan.",
      "3.3 In the event that the Borrower fails to pay his/her installments and/or any other applicable Bank charges according to the repayment plan and the Contract, the Bank has the unconditional and unilateral right to debit any of the Borrower's accounts with the Bank with the due amount.",
    ],
  },
  {
    title: "4. Rights and Obligations of Parties",
    clauses: [
      "4.1 The Bank:",
      "4.1.1 Its authorized representatives can at any time visit the business and household premises of the Borrower for monitoring purposes and to check the use of the loan and the financial situation of Borrower.",
      "4.2 The Borrower:",
      "4.2.1 In case of late payment by the Borrower according to the terms of the repayment schedule, a penalty fee of 0.5% daily of the overdue payments of principal and interest will be charged.",
    ],
  },
  {
    title: "5. Additional Conditions",
    clauses: [
      "5.1 The Borrower hereby authorizes the Bank, its agents or assignees, to disclose all necessary or relevant information in connection to the loan to third parties and/or the public, as needed, to recover any amount in overdue.",
    ],
  },
];

function TermsAndConditions() {
  return (
    <div className="boxed_wrapper ltr">
      <PageTitle
        title="Terms and Conditions"
        breadcrumbs={[
          { text: "Home", link: "/" },
          { text: "Terms and Conditions" },
        ]}
      />

      <section className="terms-condition-section">
        <div className="auto-container">
          <div className="terms-condition-content">
            <span className="document-label">Loan Contract</span>
            <h2>AccessBank Liberia Limited Loan Contract</h2>
            <p>
              AccessBank Liberia Limited, hereinafter referred to as "The Bank"
              acting as the Lender hereinafter referred to as "The Bank", in
              the person of Bank's undersigned representative, on the one part
              and Hereinafter referred to as "The Borrower"; both together
              further on referred to as "Parties", have concluded the present
              Loan Contract (hereinafter referred to as "Contract") with the
              following conditions:
            </p>

            {contractSections.map((section) => (
              <article className="contract-section" key={section.title}>
                <h3>{section.title}</h3>
                {section.clauses.map((clause) => (
                  <p key={clause}>{clause}</p>
                ))}
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default TermsAndConditions;
